export abstract class Sizes {
    static readonly MENU_BUTTON_SMALL: number = 50;
    static readonly MENU_BUTTON_LARGE: number = 100;

    static readonly CELL_WIDTH: number = 128;
    static readonly CELL_HEIGHT: number = 150;

    static readonly ACCEPT_BUTTON_CONTAINER_HEIGHT: number = 66;
    static readonly ACCEPT_BUTTON_CONTAINER_WIDTH: number = 150;

    static readonly EMERGENCY_BUTTON_CONTAINER_WIDTH: number = 32;
    static readonly EMERGENCY_BUTTON_CONTAINER_HEIGHT: number = 32;

    static readonly MENU_BUTTON_ROUND: number = 50;

    static readonly MAX_ARTIFACT_SLOTS_COUNT: number = 17;
    static readonly MAX_FORCES_SLOTS_COUNT: number = 10;

}
